import React from 'react';

import NiceicPocketGuidesHeader from './niceic_pocket_guides_header';
import NiceicPocketGuidesTable from './niceic_pocket_guides_table';

class NiceicPocketGuides extends React.PureComponent {
  constructor(props) {
    super(props);
    const { pocketGuides, loggedIn } = props;
    this.state = {
      pocketGuides,
      loggedIn,
      filteredGuides: undefined,
      selectedGuides: [],
      selectAllChecked: false,
      formSubmitted: false,
      hideTable: false,
      selectedCount: 0
    };

    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleSelectOne = this.handleSelectOne.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.toggleStaticNodes = this.toggleStaticNodes.bind(this);
  }

  componentDidMount() {
    PubSub.subscribe('POCKET-GUIDES-FORM-COMPLETE', () => {
      this.setState({
        formSubmitted: true,
        hideTable: false
      });
    });
  }

  handleClearAll(e) {
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation();

    const { pocketGuides } = this.state;

    const newPocketGuides = pocketGuides.map((p) => {
      p.checked = false;
      return p;
    });

    this.setState({
      pocketGuides: newPocketGuides,
      selectAllChecked: false,
      selectedCount: 0
    });
  }

  handleSelectAll(e) {
    const { pocketGuides, selectedCount } = this.state;
    let count = selectedCount;

    const newPocketGuides = pocketGuides.map((p) => {
      p.checked = e.target.checked;
      return p;
    });

    if (e.target.checked) {
      count = pocketGuides.length;
    } else {
      count = 0;
    }

    this.setState({
      pocketGuides: newPocketGuides,
      selectAllChecked: e.target.checked,
      selectedCount: count
    });
  }

  handleSelectOne(e, index) {
    const { pocketGuides, selectedCount } = this.state;
    let pocketGuidesCopy = JSON.parse(JSON.stringify(pocketGuides));
    let count = selectedCount;

    pocketGuidesCopy[index].checked = e.target.checked;

    if (e.target.checked) {
      count = count + 1;
    } else {
      count = count - 1;
    }

    this.setState({
      pocketGuides: pocketGuidesCopy,
      selectAllChecked: count === pocketGuides.length ? true : false,
      selectedCount: count
    });
  }

  handleDownload(e) {
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation();
    const { pocketGuides, loggedIn } = this.state;
    const filtered = pocketGuides.filter((p) => p.checked === true);

    this.toggleStaticNodes(false);

    if (loggedIn) {
      this.setState({
        filteredGuides: filtered,
        hideTable: false,
        formSubmitted: true
      });
    } else {
      this.setState({
        filteredGuides: filtered,
        hideTable: true
      });

      // Make filtered pocket guides available to the window for usage from the form
      window.NiceicPocketGuides = filtered;

      // Show form
      document
        .querySelector('.trade-hub__pocket-guides-form')
        .classList.remove('d-none');
    }
  }

  handleBack(e) {
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation();

    this.setState({ filteredGuides: undefined, hideTable: false });
    window.NiceicPocketGuides = [];

    document
      .querySelector('.trade-hub__pocket-guides-form')
      .classList.add('d-none');
    this.toggleStaticNodes(true);
  }

  toggleStaticNodes(show) {
    const staticNodes = document.querySelectorAll('.pocket-guides__static');

    for (let i = 0; i < staticNodes.length; i++) {
      const node = staticNodes[i];
      if (show) {
        node.classList.remove('pocket-guides__static--hidden');
      } else {
        node.classList.add('pocket-guides__static--hidden');
      }
    }
  }

  render() {
    const {
      pocketGuides,
      selectAllChecked,
      filteredGuides,
      formSubmitted,
      hideTable,
      selectedCount
    } = this.state;

    const { downloadIcon, warningIcon } = this.props;

    return (
      <div className="pocket-guides">
        <NiceicPocketGuidesHeader
          pocketGuides={pocketGuides}
          filteredGuides={filteredGuides}
          handleDownload={this.handleDownload}
          handleBack={this.handleBack}
          formSubmitted={formSubmitted}
          downloadIcon={downloadIcon}
          warningIcon={warningIcon}
          selectedCount={selectedCount}
        />

        <NiceicPocketGuidesTable
          pocketGuides={pocketGuides}
          filteredGuides={filteredGuides}
          handleClearAll={this.handleClearAll}
          handleSelectAll={this.handleSelectAll}
          handleSelectOne={this.handleSelectOne}
          selectAllChecked={selectAllChecked}
          formSubmitted={formSubmitted}
          hideTable={hideTable}
          selectedCount={selectedCount}
          handleDownload={this.handleDownload}
        />
      </div>
    );
  }
}

export default NiceicPocketGuides;
